const data = {
  primary: '#B48C86',
  secondary: '#e8eef9',
  header: '#707070',
  footer: '#f2f2f2',
  questionnairyMain: '#003882'
}

export default data
